const googleMapServer = 'https://maps.googleapis.com';
const iconTypeMapper = {
    SINGLE_FAMILY_HOUSE: 'sf',
    CONDO: 'condo',
    MULTI_FAMILY: 'multi',
    LAND: 'land',
    MOBILE: 'mobile',
    OTHER: 'other',
    // this case is currently not in use
    COMMERCIAL: 'other',
    // this case comes as fallback in PR property type
    ALL: 'other',
};
const iconPoiMapper = {
    cafes: 'cafes',
    grocery: 'grocery',
    parks: 'parks',
    restaurants: 'restaurants',
    shopping: 'shopping',
    gym: 'gym',
    transits: 'transits',
    school: 'school',
};

const newIconPoiMapper = {
    cafes: 'cafes',
    grocery: 'grocery_light',
    parks: 'parks',
    restaurants: 'restaurants_brand',
    shopping: 'shopping',
    gym: 'gym',
    transits: 'transits',
    school: 'school',
};

export function getIconUrl(type, cdnUrl, newDpp) {
    if(newDpp){
        if(newIconPoiMapper[type]){
            const markerPath = `images/desktop/poimarker/${newIconPoiMapper[type]}.png`;
            return `${cdnUrl}${markerPath}`;
        }
    }
    if (iconTypeMapper[type]) {
        let path = `images/desktop/pin/icon-${newDpp ? 'new-': ''}pin-${iconTypeMapper[type]}.png`;
        return `${cdnUrl}${path}`;
    } else if (iconPoiMapper[type]) {
        const markerPath = `images/desktop/poimarker/${iconPoiMapper[type]}.png`;
        return `${cdnUrl}${markerPath}`;
    } else {
        return '';
    }
}

export function getStaticStreetPath({ address, lat, lng, width = 480, height = 360, id, resolution = 1 }) {
    var streetMapPath = '/maps/api/streetview?location=';

    if (address) {
        streetMapPath += encodeURIComponent(address);
    } else if (lat && lng) {
        streetMapPath += lat + ',' + lng;
    }
    var pixelW = Math.ceil(width * resolution);
    var pixelH = Math.ceil(height * resolution);
    pixelH = Math.max(pixelH, Math.ceil(pixelW * 0.75));
    if (pixelW > 960 || pixelH > 720) {
        var scale = Math.max(pixelW / 960, pixelH / 720);
        pixelW = Math.floor(pixelW / scale);
        pixelH = Math.floor(pixelH / scale);
    }
    streetMapPath += '&size=' + pixelW + 'x' + pixelH;
    streetMapPath += '&' + id;
    return streetMapPath;
}

/**
 * Street View Metadata API (coverage / pano lookup).
 * Same key suffix pattern as getStaticStreetPath (`&` + id, e.g. `key=…`).
 * Returns the resource path only (empty string if location missing). Sign in production with
 * getGoogleMapPathWithSignature, then pass to getStaticMapUrl for the full request URL.
 */
export function getStreetViewMetadata({ address, lat, lng, id }) {
    let path = '/maps/api/streetview/metadata?location=';
    if (address) {
        path += encodeURIComponent(address);
    } else if (lat != null && lng != null) {
        path += lat + ',' + lng;
    } else {
        return '';
    }
    path += '&' + id;
    return path;
}

export function getStaticMapPath({ type = 'terrain', address, lat, lng, width = 480, height = 360, zoom, markers, id, markerCdnUrl, resolution = 1, newDpp = false, anchor = '' }) {
    var staticMapPath = '/maps/api/staticmap?center=';
    if (address) {
        staticMapPath += encodeURIComponent(address);
    } else if (lat && lng) {
        staticMapPath += lat + ',' + lng;
    }
    staticMapPath += '&maptype=' + type;
    var mapW, mapH;
    if (width <= 640) {
        mapW = Math.ceil(width);
        mapH = Math.ceil(height);
        mapH = Math.max(mapH, Math.ceil(mapW * 0.75));
    } else {
        mapW = Math.ceil(width * resolution);
        mapH = Math.ceil(height * resolution);
        mapH = Math.max(mapH, Math.ceil(mapW * 0.75));
        if (mapW > 960 || mapH > 720) {
            var capRatio = Math.max(mapW / 960, mapH / 720);
            mapW = Math.floor(mapW / capRatio);
            mapH = Math.floor(mapH / capRatio);
        }
    }
    staticMapPath += '&size=' + mapW + 'x' + mapH;
    if (zoom) {
        staticMapPath += '&zoom=' + zoom;
    }

    //expensive! google going to fetch icons from our cdn then generate the map image.
    if (markers && markers.length) {
        markers.forEach((item) => {
            if (item.type && markerCdnUrl) {
                let iconStr = encodeURIComponent(getIconUrl(item.type, markerCdnUrl, newDpp));
                staticMapPath += '&markers=';
                if (anchor) {
                    staticMapPath += 'anchor:' + anchor + '|';
                }
                staticMapPath += 'icon:' + iconStr + '|' + item.lat + ',' + item.lng;
            } else {
                let markerStr = '&markers=';
                let params = [];
                if (anchor) {
                    params.push('anchor:' + anchor);
                }
                if (item.label) {
                    params.push('label:' + item.label);
                }
                if (item.color) {
                    params.push('color:' + item.color);
                }
                params.push(item.lat + ',' + item.lng);
                markerStr += encodeURIComponent(params.join('|'));
                staticMapPath += markerStr;
            }
        });
    }
    staticMapPath += '&' + id;

    return staticMapPath;
}

export function getStaticMapUrl(path) {
    return googleMapServer + path;
}

export default {
    getStaticStreetPath,
    getStreetViewMetadata,
    getStaticMapPath,
    getStaticMapUrl,
};
